import { FC, ReactElement, memo, useState } from 'react';

import { useAppPagination } from '@/common/hooks';
import { FallbackedLayout } from '@/common/layouts';

import { SearchConsoleAccountsSearchingForm, useGetAllSearchConsoleAccountsQuery } from '@/modules/DomainsApi';

import { SearchConsoleAccountsListView } from './SearchConsoleAccountsListView';

export const SearchConsoleAccountsListContainer: FC = memo(() => {
  const { pageParam: currentPage, handleChangePage } = useAppPagination();

  const [search, setSearch] = useState<string | undefined>(undefined);

  const {
    data: searchConsoleAccountsListData,
    error: searchConsoleAccountsListError,
    isLoading: isSearchConsoleAccountsListLoading,
    isFetching: isSearchConsoleAccountsListFetching,
    isError: isSearchConsoleAccountsListError
  } = useGetAllSearchConsoleAccountsQuery({ page: currentPage }, search)();

  return (
    <FallbackedLayout
      isLoading={ isSearchConsoleAccountsListLoading }
      error={ searchConsoleAccountsListError }
      isError={ isSearchConsoleAccountsListError }
      data={ searchConsoleAccountsListData }
    >
      { (searchConsoleAccountsList): ReactElement => (
        <>
          <SearchConsoleAccountsSearchingForm search={ search } handleSubmitSearch={ setSearch }/>
          <SearchConsoleAccountsListView
            currentPage={ currentPage }
            searchConsoleAccountsListItems={ searchConsoleAccountsList.items }
            searchConsoleAccountsListTotalItems={ searchConsoleAccountsList.meta.totalItems }
            searchConsoleAccountsListItemsPerPage={ searchConsoleAccountsList.meta.itemsPerPage }
            isLoading={ isSearchConsoleAccountsListFetching }
            handleChangePage={ handleChangePage }
          />
        </>
      ) }
    </FallbackedLayout>
  );
});
